export enum IdentityTypeEnum {
  Member = 1,
  NonMember = 2
}
